export const ElVideo = () => import('../..\\components\\ElVideo\\index.vue' /* webpackChunkName: "components/el-video" */).then(c => wrapFunctional(c.default || c))
export const BatchDownload = () => import('../..\\components\\BatchDownload\\index.vue' /* webpackChunkName: "components/batch-download" */).then(c => wrapFunctional(c.default || c))
export const Empty = () => import('../..\\components\\Empty\\index.vue' /* webpackChunkName: "components/empty" */).then(c => wrapFunctional(c.default || c))
export const FolderSelect = () => import('../..\\components\\FolderSelect\\index.vue' /* webpackChunkName: "components/folder-select" */).then(c => wrapFunctional(c.default || c))
export const IconSelect = () => import('../..\\components\\IconSelect\\index.vue' /* webpackChunkName: "components/icon-select" */).then(c => wrapFunctional(c.default || c))
export const IconSelectRequireIcons = () => import('../..\\components\\IconSelect\\requireIcons.js' /* webpackChunkName: "components/icon-select-require-icons" */).then(c => wrapFunctional(c.default || c))
export const FilePreview = () => import('../..\\components\\FilePreview\\index.vue' /* webpackChunkName: "components/file-preview" */).then(c => wrapFunctional(c.default || c))
export const Loading = () => import('../..\\components\\Loading\\index.vue' /* webpackChunkName: "components/loading" */).then(c => wrapFunctional(c.default || c))
export const MendianPreview = () => import('../..\\components\\MendianPreview\\index.vue' /* webpackChunkName: "components/mendian-preview" */).then(c => wrapFunctional(c.default || c))
export const ModelConfirm = () => import('../..\\components\\ModelConfirm\\index.vue' /* webpackChunkName: "components/model-confirm" */).then(c => wrapFunctional(c.default || c))
export const Navbar = () => import('../..\\components\\Navbar\\index.vue' /* webpackChunkName: "components/navbar" */).then(c => wrapFunctional(c.default || c))
export const Pagination = () => import('../..\\components\\Pagination\\index.vue' /* webpackChunkName: "components/pagination" */).then(c => wrapFunctional(c.default || c))
export const RightMenuBar = () => import('../..\\components\\RightMenuBar\\index.vue' /* webpackChunkName: "components/right-menu-bar" */).then(c => wrapFunctional(c.default || c))
export const SelectView = () => import('../..\\components\\SelectView\\index.vue' /* webpackChunkName: "components/select-view" */).then(c => wrapFunctional(c.default || c))
export const Sidebar = () => import('../..\\components\\Sidebar\\index.vue' /* webpackChunkName: "components/sidebar" */).then(c => wrapFunctional(c.default || c))
export const SidebarItem = () => import('../..\\components\\Sidebar\\Item.vue' /* webpackChunkName: "components/sidebar-item" */).then(c => wrapFunctional(c.default || c))
export const SidebarLink = () => import('../..\\components\\Sidebar\\Link.vue' /* webpackChunkName: "components/sidebar-link" */).then(c => wrapFunctional(c.default || c))
export const SvgIcon = () => import('../..\\components\\SvgIcon\\index.vue' /* webpackChunkName: "components/svg-icon" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
